module.exports = __webpack_public_path__ + "img/10.f222de79.jpg";